const closeButtonLabel = "Stäng";
const svSE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  svSE as default
};
